import { BaseModel, type RelationConfig } from './base';
import { Form } from './form';

export class ServiceForm extends BaseModel {
  id!: number;
  idServiceForm!: number;
  scheduleOffset!: number;
  frequency!: ServiceFormFrequency;
  requirementMode!: ServiceFormRequirementMode;

  form?: Form;

  static override relations(): RelationConfig {
    return {
      form: { type: Form },
    };
  }

  override objectID(): string {
    return this.idServiceForm?.toString() || '';
  }

  get scheduleOffsetMode(): 'before' | 'after' {
    return this.scheduleOffset > -1 ? 'after' : 'before';
  }

  set scheduleOffsetMode(value: 'before' | 'after') {
    const isBefore = value === 'before';

    if (isBefore) {
      this.scheduleOffset = -Math.abs(this.scheduleOffset);
    } else {
      this.scheduleOffset = Math.abs(this.scheduleOffset);
    }
  }

  get scheduleOffsetValue(): number {
    return Math.abs(this.scheduleOffset);
  }

  set scheduleOffsetValue(value: number) {
    const isBefore = this.scheduleOffsetMode === 'before';

    if (isBefore) {
      this.scheduleOffset = -Math.abs(value);
    } else {
      this.scheduleOffset = Math.abs(value);
    }
  }

  get isRequirementModeScheduled(): boolean {
    return this.requirementMode === ServiceFormRequirementMode.scheduled;
  }
}

export enum ServiceFormFrequency {
  reservation = 0,
  customer = 1,
  service = 2,
}

export const ServiceFormFrequencyLabels: Record<ServiceFormFrequency, string> = {
  [ServiceFormFrequency.reservation]: 'service.form.frequency.reservation',
  [ServiceFormFrequency.customer]: 'service.form.frequency.customer',
  [ServiceFormFrequency.service]: 'service.form.frequency.service',
};

export enum ServiceFormRequirementMode {
  confirmation = 0,
  scheduled = 1,
  internal = 2,
}

export const ServiceFormRequirementModeLabels: Record<ServiceFormRequirementMode, string> = {
  [ServiceFormRequirementMode.confirmation]: 'service.form.requirement.confirmation',
  [ServiceFormRequirementMode.scheduled]: 'service.form.requirement.scheduled',
  [ServiceFormRequirementMode.internal]: 'service.form.requirement.internal',
};